export const confidentialiteTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Politique de confidentialité',
  hero_h1: 'Politique de confidentialité',
  hero_date: 'Dernière mise à jour : 16 mai 2026',

  // Intro
  intro_text: "Couvreur-Lévis.com respecte la vie privée de ses visiteurs et clients. La présente politique explique quelles données personnelles sont collectées, comment elles sont utilisées, et vos droits selon la Loi 25 du Québec. Nous nous engageons à protéger vos renseignements personnels et à les traiter avec la plus grande rigueur.",

  // Responsable
  responsable_h2: 'Responsable du traitement des données',
  responsable_raison: 'Raison sociale',
  responsable_raison_val: 'Couvreur-Lévis.com',
  responsable_adresse: 'Adresse',
  responsable_adresse_val: 'Lévis, QC, Canada',
  responsable_prp: 'Personne responsable de la protection des renseignements personnels',
  responsable_prp_val: "L'éditeur du site, joignable à contact@couvreur-levis.com",
  responsable_email: 'Courriel',
  responsable_email_val: 'contact@couvreur-levis.com',
  responsable_tel: 'Téléphone',
  responsable_tel_val: '418-476-9950',

  // Données collectées
  donnees_h2: 'Quelles données personnelles collectons-nous',
  donnees_1: 'Nom et prénom',
  donnees_2: 'Adresse postale ou secteur',
  donnees_3: 'Numéro de téléphone',
  donnees_4: 'Adresse courriel',
  donnees_5: 'Type de projet et détails techniques',
  donnees_6: 'Données de navigation (cookies, IP anonymisée, pages visitées)',

  // Finalités
  finalites_h2: 'Pourquoi collectons-nous ces données',
  finalites_1: 'Répondre aux demandes de soumission',
  finalites_2: 'Fournir nos services de couverture de toiture',
  finalites_3: 'Communiquer avec vous concernant votre projet',
  finalites_4: 'Améliorer notre site web et nos services',
  finalites_5: 'Respecter nos obligations légales et fiscales',

  // Conservation
  conservation_h2: 'Durée de conservation',
  conservation_text: "Vos données sont conservées le temps nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées. Données de soumission : 3 ans après le dernier contact. Données clients actifs : 7 ans (obligations fiscales et comptables). Données de navigation : 13 mois maximum.",

  // Partage
  partage_h2: 'Partage des données',
  partage_text: "Vos données personnelles ne sont jamais vendues à des tiers. Elles peuvent être partagées avec : nos sous-traitants techniques (hébergement web, service de courriel), nos partenaires couvreurs certifiés pour l'exécution de votre projet, et les autorités compétentes si requis par la loi.",

  // Droits Loi 25
  droits_h2: 'Vos droits selon la Loi 25',
  droits_1: "Droit d'accès à vos données personnelles",
  droits_2: 'Droit de rectification des données inexactes',
  droits_3: 'Droit de suppression (sauf obligations légales)',
  droits_4: 'Droit de retirer votre consentement à tout moment',
  droits_5: 'Droit de portabilité de vos données',
  droits_6: 'Droit à la désindexation',
  droits_exercer: 'Pour exercer vos droits :',
  droits_exercer_text: "Envoyez un courriel à contact@couvreur-levis.com ou appelez au 418-476-9950. Nous répondrons dans un délai de 30 jours selon les exigences de la Loi 25.",

  // Cookies
  cookies_h2: "Utilisation des témoins (cookies)",
  cookies_text: "Le site utilise des témoins pour : assurer le bon fonctionnement technique du site, mesurer la fréquentation (Google Analytics, données anonymisées), et améliorer l'expérience utilisateur. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur à tout moment.",

  // Sécurité
  securite_h2: 'Sécurité des données',
  securite_text: "Nous utilisons des mesures techniques (connexion HTTPS, mots de passe forts, accès restreint) et organisationnelles pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.",

  // Modifications
  modifications_h2: 'Modifications de la politique',
  modifications_text: "Cette politique de confidentialité peut être mise à jour à tout moment. La date de dernière mise à jour est indiquée en haut de page. Nous vous encourageons à consulter cette page régulièrement.",

  // Contact
  contact_h2: 'Nous contacter',
  contact_text: "Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous à contact@couvreur-levis.com ou au 418-476-9950.",

  // Shared
  phone_number: '418-476-9950',
};

export default confidentialiteTranslations;